// FUNDIO Master-Logo (Logo Lock 2026). Nur diese beiden Varianten sind erlaubt.
// light=true  -> WEISS/Gold-Variante fuer dunkle Flaechen (max. Kontrast)
// light=false -> FARBIG/Navy-Variante fuer helle Flaechen
export function Logo({ light = true, size = "md", className = "" }) {
  const h = size === "lg" ? "h-11" : "h-9";
  const src = light ? "/fundio-logo-white.png" : "/fundio-logo-color.png";
  return (
    <img
      src={src}
      alt="Fundio"
      draggable="false"
      className={`${h} w-auto select-none object-contain ${className}`}
    />
  );
}
